"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpportunityRfpCoverDetail = void 0;
const tslib_1 = require("tslib");
const typeorm_1 = require("typeorm");
const opportunity_entity_1 = require("./opportunity.entity");
const opportunity_cover_entity_1 = require("./opportunity-cover.entity");
let OpportunityRfpCoverDetail = class OpportunityRfpCoverDetail {
};
exports.OpportunityRfpCoverDetail = OpportunityRfpCoverDetail;
tslib_1.__decorate([
    (0, typeorm_1.PrimaryGeneratedColumn)(),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCoverDetail.prototype, "id", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "opportunity_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCoverDetail.prototype, "opportunityId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_map_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCoverDetail.prototype, "coverMapId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "policy_type_id", type: "int", nullable: false }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCoverDetail.prototype, "policyTypeId", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_name", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpCoverDetail.prototype, "coverName", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "cover_response", type: "varchar", nullable: false }),
    tslib_1.__metadata("design:type", String)
], OpportunityRfpCoverDetail.prototype, "coverResponse", void 0);
tslib_1.__decorate([
    (0, typeorm_1.CreateDateColumn)({ name: "created_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], OpportunityRfpCoverDetail.prototype, "createdAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.UpdateDateColumn)({ name: "updated_at", type: "timestamptz" }),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], OpportunityRfpCoverDetail.prototype, "updatedAt", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "created_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCoverDetail.prototype, "createdBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.Column)({ name: "updated_by", type: "int", nullable: true }),
    tslib_1.__metadata("design:type", Number)
], OpportunityRfpCoverDetail.prototype, "updatedBy", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_entity_1.Opportunity, (opportunity) => opportunity.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "opportunity_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityRfpCoverDetail.prototype, "opportunity", void 0);
tslib_1.__decorate([
    (0, typeorm_1.ManyToOne)(() => opportunity_cover_entity_1.OpportunityCoverMap, (coverMap) => coverMap.id, {
        onDelete: "CASCADE",
    }),
    (0, typeorm_1.JoinColumn)({ name: "cover_map_id" }),
    tslib_1.__metadata("design:type", Object)
], OpportunityRfpCoverDetail.prototype, "coverMap", void 0);
exports.OpportunityRfpCoverDetail = OpportunityRfpCoverDetail = tslib_1.__decorate([
    (0, typeorm_1.Entity)("opportunity_rfp_cover_detail")
], OpportunityRfpCoverDetail);
